export class ReportModel{
    id?: number;
    message?:string;
    Type?:string;
    commentId ?:number;
    userId?:number;
    
    
    


    constructor(item?:ReportModel){
        item = item? item:{};
        this.id = item.id? item.id:0;
        this.message = item.message? item.message:'';
        this.Type = item.Type? item.Type:'';
        this.commentId = item.commentId? item.commentId:0;
        this.userId = item.userId? item.userId:0;
      
        
    
    }

}